import { Component, OnInit } from '@angular/core';
import { DimensionsService } from '../services/dimensions.service';
import { MapService } from '../services/map.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  clientWidth: number;

  constructor(private dimensionsService: DimensionsService, private mapService: MapService) { }

  ngOnInit() {
    this.clientWidth = this.dimensionsService.getClientWidth();
  }

  setMapView() {
    this.mapService.showMap();
  }

}
